import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectQuizzes, selectTotal, selectPage, selectLimit } from '../selectors/quizzes.selector';
import { quizzesActions } from '../actions/quizzes.actions';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class QuizzesFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly quizzes$ = this.store.select(selectQuizzes);
    readonly total$ = this.store.select(selectTotal);
    readonly page$ = this.store.select(selectPage);
    readonly limit$ = this.store.select(selectLimit);

    readonly quizzes = this.store.selectSignal(selectQuizzes);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly page = this.store.selectSignal(selectPage);
    readonly limit = this.store.selectSignal(selectLimit);

    getQuizzes(value: PaginationParams): void {
        this.store.dispatch(quizzesActions.getQuizzes({ value }));
    }

    clear(): void {
        this.store.dispatch(quizzesActions.clear());
    }
}
